export default __webpack_public_path__ + "static/media/affairs_briefcase.b59f6747.svg";